const SECOND_MS = 1000;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_MINUTE = 60;
const twoDigits = (value) => String(value).padStart(2, '0');
/** A duration as "42:07", or "1:42:07" once it reaches an hour. Negative durations read "0:00". */
export function formatDuration(durationMs) {
    const totalSeconds = Math.max(0, Math.floor(durationMs / SECOND_MS));
    const hours = Math.floor(totalSeconds / SECONDS_PER_HOUR);
    const minutes = Math.floor((totalSeconds % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
    const seconds = twoDigits(totalSeconds % SECONDS_PER_MINUTE);
    if (!hours)
        return `${String(minutes)}:${seconds}`;
    return `${String(hours)}:${twoDigits(minutes)}:${seconds}`;
}
//# sourceMappingURL=format-duration.js.map